import { createQueryParams } from '../helpers/utils';

export function generateCRUDUrls(baseUrl) {
	return {
		GET: `${baseUrl}/{pk}`,
		LIST: `${baseUrl}/`,
		CREATE: `${baseUrl}/`,
		UPDATE: `${baseUrl}/{pk}`,
		DELETE: `${baseUrl}/{pk}`,
		CREATE_DEMO: `${baseUrl}/demo-get-field-data/`,
	};
}

export function generateFinalUrl(url, pk = null, queryValues = null) {
	if (queryValues) {
		const params = createQueryParams(queryValues);
		url = `${url}?${params}`;
	}

	if (pk) {
		url = url.replace('{pk}', pk);
	}
	return url;
}
